import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import api, { getRoles } from '../../utils/authUtils';

const ProtectedAttendeeRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await api.get('/api/protected');
        const roles = getRoles();
        setAuthStatus(roles.includes('ATTENDEE') || roles.includes('ADMIN') || roles.includes('SPEAKER') ? 'authenticated' : 'unauthenticated');
      } catch (error) {
        if (error.message === 'Session expired. Please login again.') {
          navigate('/login?session_expired=true', { replace: true });
        } else {
          setAuthStatus('unauthenticated');
        }
      }
    };

    checkAuth();
  }, [navigate]);

  if (authStatus === 'checking') {
    return <div>Loading...</div>;
  }

  if (authStatus === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedAttendeeRoute;
